import React, { Component } from 'react'
import {downloadQuoteSpecimenSubmission} from '../api'
import PDFLink from './GenerateLink'
import { toastify } from '../../components/shared/Toasts';
import ToastMessagesPdf from './ToastMessagesPdf';

class PDFPreviewQuoteSpecimen extends  Component
{

    constructor(props)
    {
        super(props);
                this.state={
                error:{},
                pdfLink:'',
                loading:false,   
                };
            }
           
                async componentWillMount() {
                    try {
                        const {data}= await downloadQuoteSpecimenSubmission (this.props.user,this.props.submissionid, false);
                        
                        this.setState({
                            pdfLink: data,
                            loading:true,
                           
                        })
                        } catch (error) {
                            this.props.onHide()
                            this.setState({
                                loading:false
                            })
                            toastify.error(ToastMessagesPdf.failPdf);
                        }
                  }
    render(){
        
        return (
            <div>
            {  <PDFLink pdfLink={this.state.pdfLink}  show={this.props.show} onHide={this.props.onHide} loading={this.state.loading} /> }
           </div>
        )
    }
}

export default PDFPreviewQuoteSpecimen;

